import { AdminPromptVariables } from '../PromptsVariables';

import { HowToUse } from './components/HowToUse';
import { PromptsPage } from './components/PromptsPage';

import { Card, CardContent } from '@/components/ui/Card';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/Tabs';

export function AdminPrompts() {
  return (
    <Card className="min-h-screen rounded-lg shadow">
      <CardContent>
        <div className="mt-2 border-b bg-white">
          <div className="container mx-auto px-4 py-6">
            <h1 className="text-2xl font-bold text-gray-900">
              Prompt & Query Manager
            </h1>
            <p className="mt-1 text-gray-600">
              Configure prompts with dynamic variables based on queries
            </p>
          </div>
        </div>
        <div className="rounded-lg bg-gray-50">
          <HowToUse />
          <div className="container mx-auto px-4 py-6">
            <Tabs defaultValue="prompts" className="space-y-6">
              <TabsList className="mt-4 grid w-full max-w-md grid-cols-2">
                <TabsTrigger value="prompts">Prompts</TabsTrigger>
                <TabsTrigger value="variables">Variables</TabsTrigger>
              </TabsList>

              <TabsContent value="prompts">
                <PromptsPage />
              </TabsContent>

              <TabsContent value="variables">
                <AdminPromptVariables />
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
